import {SectionType} from '../graphql/generated/types';

export function isRankingSection(sectionType: SectionType) {
  return [
    SectionType.LandingRanking,
    SectionType.RankingV2,
    SectionType.Ranking,
    SectionType.MainRanking,
  ].includes(sectionType);
}
